// Normal range of a series of readiness values (a question's answers, or the daily totals): the
// middle 80% of the values, i.e. the 10th to the 90th percentile. It is robust to a single odd
// day. Port of msb-mobile src/helpers/readiness/normalRange.ts; both must give the same numbers.

const LOW_PERCENTILE = 0.1;
const HIGH_PERCENTILE = 0.9;

// Absorbs floating point noise (e.g. 3.0000000000000004) before ceil/floor
const ROUNDING_EPSILON = 1e-9;

// Linear interpolation between closest ranks (same as numpy's default). `sorted` ascending.
const percentile = (sorted, p) => {
  const position = p * (sorted.length - 1);
  const lower = Math.floor(position);
  const upper = Math.min(lower + 1, sorted.length - 1);
  return sorted[lower] + (position - lower) * (sorted[upper] - sorted[lower]);
};

// Raw (unrounded) range, or null when there are no values.
export const computeNormalRange = (values) => {
  if (!Array.isArray(values) || values.length === 0) return null;
  const sorted = [...values].sort((a, b) => a - b);
  return {
    lo: percentile(sorted, LOW_PERCENTILE),
    hi: percentile(sorted, HIGH_PERCENTILE),
  };
};

// Whole-number range for series of integers: keeps only the integers inside the raw range, so the
// range shown can never contradict the status next to it (raw 15.4–18.1 shows as 16–18, and a 15
// is below it in both).
export const toWholeNumberRange = (range) => {
  if (!range) return null;
  return {
    lo: Math.ceil(range.lo - ROUNDING_EPSILON),
    hi: Math.floor(range.hi + ROUNDING_EPSILON),
  };
};
